import { styled } from '@mui/material/styles';

import { rem, Theme } from '../../../theme';
import { AlertMessage } from '../../AlertMessage';
import { Paragraph } from '../../Paragraph';

export const StyledAlertContainer = styled(AlertMessage)`
    ${({ theme }: { theme: Theme }) => `
        margin-top: ${theme.tggSpacing(rem(2), 5)};
	`}
`;

export const StyledParagraph = styled(Paragraph)`
    ${({ theme }: { theme: Theme }) => theme.breakpoints.up('desktop')} {
        text-align: center;
    }
    text-align: left;
`;
